export const SPENT_CHART_HEIGHT_PX = 75;
export const SPENT_CHART_WIDTH_PX = 150;
export const SPENT_CHART_CX = 70;
export const SPENT_CHART_CY = 75;
export const SPENT_CHART_INNER_RADIUS = 50;
export const SPENT_CHART_OUTER_RADIUS = 75;
